export const notificationConstants = {
    SUCCESS: 'NOTIFICATION_SUCCESS',
    ERROR: 'NOTIFICATION_ERROR',
    CLEAR: 'NOTIFICATION_CLEAR'
};